import { reduce } from 'lodash-es';

// GLOBAL BEHAVIOR

// Turn off highlightWeekends unless granularity daily
const turnOfHighlightWeekends = (prevState, nextGranularity) => {
  const {
    chartSettings: { appearance },
  } = prevState;

  if (nextGranularity !== 'daily' && appearance.includes('highlightWeekends')) {
    return {
      chartSettings: {
        ...prevState.chartSettings,
        appearance: appearance.filter((option) => option !== 'highlightWeekends'),
      },
    };
  }

  return {};
};

// Turn off stacked if store comparison
const turnOfStacked = (prevMetric, nextOppositeMetric, appearance = []) => {
  if (
    nextOppositeMetric.metric &&
    prevMetric.metric === nextOppositeMetric.metric &&
    appearance.includes('stacked')
  ) {
    return { appearance: appearance.filter((option) => option !== 'stacked') };
  }

  return {};
};

// Turn off percentage if store comparison with stacked
const turnOfPercentage = (prevState, nextAppearance) => {
  const {
    chartMetrics: { primaryMetric, secondaryMetric },
  } = prevState;

  if (primaryMetric.metric === secondaryMetric.metric && nextAppearance.includes('stacked')) {
    return { percentage: undefined };
  }

  return {};
};

// REDUCER
const isChartMetricsOption = (key) => ['primaryMetric', 'secondaryMetric'].includes(key);
const isChartSettingsOption = (key) => ['metricView', 'appearance'].includes(key);

export default function reducer(state, action) {
  switch (action.type) {
    case 'CHANGE_GRANULARITY':
      return {
        ...state,
        ...turnOfHighlightWeekends(state, action.granularity),
        granularity: action.granularity,
      };

    case 'CHANGE_PRIMARY_METRIC':
      return {
        ...state,
        chartMetrics: {
          ...state.chartMetrics,
          primaryMetric: {
            ...state.chartMetrics.primaryMetric,
            ...action.primaryMetric,
          },
          ...turnOfStacked(
            state.chartMetrics.secondaryMetric,
            action.primaryMetric,
            state.chartSettings.appearance
          ),
        },
      };

    case 'CHANGE_SECONDARY_METRIC':
      return {
        ...state,
        chartMetrics: {
          ...state.chartMetrics,
          secondaryMetric: {
            ...state.chartMetrics.secondaryMetric,
            ...action.secondaryMetric,
          },
          ...turnOfStacked(
            state.chartMetrics.primaryMetric,
            action.secondaryMetric,
            state.chartSettings.appearance
          ),
        },
      };

    case 'CHANGE_APPEARANCE':
      return {
        ...state,
        chartSettings: {
          ...state.chartSettings,
          appearance: action.appearance,
        },
        ...turnOfPercentage(state, action.appearance),
      };

    case 'CHANGE_METRIC_VIEW':
      return {
        ...state,
        chartSettings: {
          ...state.chartSettings,
          metricView: action.metricView,
          ...(action.metricView
            ? turnOfStacked(
                state.chartMetrics.primaryMetric,
                state.chartMetrics.secondaryMetric,
                state.chartSettings.appearance
              )
            : {}),
        },
      };

    case undefined:
      return {
        ...state,
        ...reduce(
          action,
          (memo, value, key) => {
            if (isChartMetricsOption(key)) {
              return {
                ...memo,
                chartMetrics: {
                  ...state.chartMetrics,
                  ...(memo.chartMetrics || {}),
                  [key]: {
                    ...state.chartMetrics[key],
                    ...value,
                  },
                },
              };
            }
            if (isChartSettingsOption(key)) {
              return {
                ...memo,
                chartSettings: {
                  ...state.chartSettings,
                  ...(memo.chartSettings || {}),
                  [key]: value,
                },
              };
            }
            return {
              ...memo,
              [key]: value,
            };
          },
          {}
        ),
      };

    default:
      return state;
  }
}
